/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */


// Select all elements with the class 'loadall'
const loadAllButtons = document.querySelectorAll('.loadall');

// Loop through the NodeList and add event listeners to each element
loadAllButtons.forEach(button => {
    button.addEventListener('click', function(e) {

        // Construct the child selector using the dataset parentId attribute
        let childSelector = `#${e.target.dataset.parentId} .accordion-item`;
        let accordionItems = document.querySelectorAll(childSelector);

        // Show all matching accordion items
        accordionItems.forEach(item => {
            item.classList.remove('d-none');
        });

        // Hide the clicked button
        e.target.style.display = 'none';
    });
});


